
import { GET_NETWORK_CITIES, GET_NEXT_DESTINATION, GET_CITY_DEPARTURE } from '../graphql/queries/getCities';
import { store } from '../index';
import { SET_CITIES, SET_NEXT_DESTINATIONS, SET_CITIES_DEPARTURES } from './types';
import { history } from '../components/App';
import { get } from '../helpers/objectHelper';


/**
 * Get CYO/CYO network cities
 * 
 * @param {object} client - Apollo client
 * @param {string} networkID - Network ID - CYO, CYU
 */
export async function GetCities(client, networkID){
    try{
        const response = await client.query({query:GET_NETWORK_CITIES, variables:{networkID:networkID} });    
        await store.dispatch({ type: SET_CITIES, payload:response.data.networkCities});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = get([0, "extensions", "response", "url"], graphQLErrors, "");
            const hasReponseStatus = get([0, "extensions", "response", "status"], graphQLErrors, "");
            console.error(`${get([0, "message"], graphQLErrors, "")} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return get([0, "message"], graphQLErrors, "");
        }
    }  
}


/**
 * Get next destination or products for CYO/CYO network city 
 * 
 * @param {object} client - Apollo client
 * @param {string} bookingId - id of the booking
 * @param {string} maxWait - wait time of previous stop
 */
export async function GetNextDestination(client, bookingId, maxWait = 7){
 
    try{
        const response = await client.query({query:GET_NEXT_DESTINATION, variables:{bookingId:bookingId, maxWait:maxWait}, fetchPolicy:"no-cache"});
        await store.dispatch({ type: SET_NEXT_DESTINATIONS, payload:response.data.next});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = get([0, "extensions", "response", "url"], graphQLErrors, "");
            const hasReponseStatus = get([0, "extensions", "response", "status"], graphQLErrors, "");
            console.error(`${get([0, "message"], graphQLErrors, "")} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return get([0, "message"], graphQLErrors, "");
        }
    }     
}


/**
 * Get next destination or products for CYO/CYO network city 
 * 
 * @param {object} client - Apollo client
 * @param {string} cityName - Next departure city name
 * @param {string} date - Next departure city date
 */
export async function GetCityDeparture(client, cityName, date = ""){
    try{
        const response = await client.query({query:GET_CITY_DEPARTURE, variables:{cityName:cityName, date:date}, fetchPolicy:"no-cache"});

        await store.dispatch({ type: SET_CITIES_DEPARTURES, payload:response.data.getCityDepartures});
        
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = get([0, "extensions", "response", "url"], graphQLErrors, "");
            const hasReponseStatus = get([0, "extensions", "response", "status"], graphQLErrors, "");
            console.error(`${get([0, "message"], graphQLErrors, "")} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return get([0, "message"], graphQLErrors, "");
        }
    }   
}
